<template>
  <div class="input">
    <p v-if="label" class="label">
      {{label}}
      <span v-if="isRequired && !dontShowRequired">*必須</span>
    </p>

    <div class="container">
      <Field
        v-if="!noVeeValidate"
        :name="name"
        :value="modelValue"
        :type="type"
        :placeholder="placeholder"
        as="input"
        :rules="rules"
        :validate-on-input="true"
        @input="$emit('update:modelValue', $event.target.value)"
        :class="{ 'have-error-display': haveErrorDisplay && !sublabel, 'display-error': displayError }"
      />

      <input
        v-else
        :name="name"
        :value="modelValue"
        :type="type"
        :placeholder="placeholder"
        @input="$emit('update:modelValue', $event.target.value)"
      />

      <p v-if="sublabel" class="sublabel"
        :class="{ 'have-error-display': haveErrorDisplay }"
      >
        {{sublabel}}
      </p>

      <div class="error-contents" v-if="haveErrorDisplay"
        :class="{ hidden: !displayError, 'below-sublabel': sublabel }"
      >
        <p v-if="errorMessage !== 'User already exists'">※{{errorMessage}}</p>

        <p v-else class="login">既にアカウント登録されているため<a href="/">こちらから</a>ログインしてください。</p>
      </div>
    </div>
  </div>
</template>

<script>
import { Field } from "vee-validate";

export default {
  name: 'Input',

  components: {
    Field
  },

  props: {
    modelValue: {
      type: String,
      required: true
    },

    name: {
      type: String,
      required: true
    },
    
    type: {
      type: String,
      required: true
    },

    placeholder: {
      type: String,
      default: ''
    },

    rules: {
      type: String,
      default: ''
    },

    label: {
      type: [String, null],
      default: null
    },

    sublabel: {
      type: [String, null],
      default: null
    },

    haveErrorDisplay: {
      type: Boolean,
      default: true
    },

    displayError: {
      type: Boolean,
      default: false
    },

    errorMessage: {
      type: String,
      default: ''
    },

    dontShowRequired: {
      type: Boolean,
      default: false
    },

    noVeeValidate: {
      type: Boolean,
      default: false
    }
  },

  emits: ['update:modelValue'],

  computed: {
    isRequired() {
      return this.rules.includes('required')
    }
  }
}
</script>

<style scoped>
.input {
  width: 100%;
}

.input p.label {
  font-size: 14px;
  line-height: 21px;
  color: black;
  margin-bottom: 10px;
}

.input p.label span {
  font-size: 12px;
  line-height: 18px;
  color: #f00;
}

.input .container {
  position: relative;
}

.input input {
  width: 100%;
  height: 40px;
  font-size: 14px;
  line-height: 21px;
  padding: 0;
  color: black !important;
  background-color: white !important;
  border: 1px solid #999;
  border-radius: 4px;
  padding: 0px 10px;
  box-sizing: border-box;
}

.input input.have-error-display {
  margin-bottom: 18px;
}

.input input.display-error {
  border-color: #f00;
  -webkit-box-shadow: 0 0 3px #f00;
          box-shadow: 0 0 3px #f00;
}

::-webkit-input-placeholder { /* WebKit, Blink, Edge */
    color:    #999;
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
   color:    #999;
   opacity:  1;
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
   color:    #999;
   opacity:  1;
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
   color:    #999;
}
::-ms-input-placeholder { /* Microsoft Edge */
   color:    #999;
}

::placeholder { /* Most modern browsers support this now. */
   color:    #999;
}

.input p.sublabel {
  font-size: 13px;
  line-height: 19.5px;
  color: black;
  margin-top: 5px;
}

.input p.sublabel.have-error-display {
  padding-bottom: 18px;
}

.input .error-contents {
  -webkit-transition-duration: 0.3s;
  -o-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-timing-function: ease-in-out;
  -o-transition-timing-function: ease-in-out;
  transition-timing-function: ease-in-out;
  -webkit-transform: translate3d(0, 0, 0);
  transform: translate3d(0, 0, 0);
  position: absolute;
  top: 44px;
}

.input .error-contents p {
  font-size: 12px;
  line-height: 18px;
  color: red;
  opacity: 1;
}

.input .error-contents.hidden {
  opacity: 0;
  -webkit-transform: translate3d(0, 20px, 0);
  transform: translate3d(0, 20px, 0);
}

.input .error-contents.below-sublabel {
  top: initial;
  bottom: -2px;
}
</style>
